export default __webpack_public_path__ + "static/media/close_grey.d35fdb25.svg";